import React, { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { imagesSelector } from "../../../../../redux/images/selectors";
import { IClubImage } from "../../../../../redux/images/types";
import Styles from "./OurClub.module.scss";
import {fetchGetClubImages} from "../../../../../redux/images/asyncActions";
import {useAppDispatch} from "../../../../../redux/store";
import {Slider, Preloader} from "../../../../../components";
import { Swiper as SwiperType } from "swiper";

export const OurClub: React.FC = () => {
    const dispatch = useAppDispatch();
    const { clubImages, isLoading } = useSelector(imagesSelector);
    const swiperRef = useRef<SwiperType | null>(null);

    useEffect(() => {
        dispatch(fetchGetClubImages());
    }, [dispatch]);

    const imagesClubArray = Array.isArray(clubImages) 
        ? clubImages.map((imageItem: IClubImage) => {
            return imageItem.url || imageItem.img_url || "";
        }).filter(url => url !== "")
        : [];

    const handleSmallImageClick = (index: number) => {
        if (swiperRef.current) {
            swiperRef.current.slideTo(index);
        }
    };

    const renderSmallImages = () => {
        if (imagesClubArray.length === 0) {
            return null;
        }
        return imagesClubArray.map((imageUrl, index) => {
            return (
                <img 
                    key={index} 
                    className={Styles.imgAdaptiveSub} 
                    src={imageUrl} 
                    alt={`Фото клуба ${index + 1}`}
                    onClick={() => handleSmallImageClick(index)}
                />
            );
        });
    };

    if (isLoading) {
        return (
            <div className={Styles.wrapper}>
                <Preloader />
            </div>
        );
    }

    if (imagesClubArray.length === 0) {
        return (
            <div className={Styles.wrapper}>
                <div>Нет доступных фотографий</div>
            </div>
        );
    }

    return (
        <div className={Styles.wrapper}>
            <div className={Styles.slider}>
                <Slider 
                    newStyle={'slider_big_img'} 
                    images={imagesClubArray}
                    onSwiper={(swiper) => {
                        swiperRef.current = swiper;
                    }}
                />
            </div>
            {imagesClubArray.length > 0 && (
                <div className={Styles.imgContainer}>
                    {renderSmallImages()}
                </div>
            )}
        </div>
    );
};

